const textConfig = {
  name: 'Glowforge:Carousel',
  image: 'https://cdn.builder.io/api/v1/image/assets%2F69fac0673d2644f0a0a962e1cb3045ef%2F8fbbb3351b2945b1a5299f15706834df?quality=60&width=200&height=200',
  inputs: [
    {
      name: 'scrollStepMultiply',
      type: 'number',
      defaultValue: 1,
    }
  ],
  defaultChildren: [
    {
      '@type': '@builder.io/sdk:Element',
      component: {
        name: 'Glowforge:Text',
        options: {
          text: 'You can edit the contents of this example!',
        },
      },
    },
  ],
};

export default textConfig;
